import moment from 'moment'

export const rebaseShiftTimes = ({
  previousDate,
  nextDate,
  startTime,
  splits,
}) => {
  const previousDay = moment(previousDate).startOf('day')
  const nextDay = moment(nextDate).startOf('day')

  const rebaseTime = (value, preserveDayOffset) => {
    const source = moment(value)
    const dayOffset = preserveDayOffset
      ? Math.min(
          Math.max(
            source
              .clone()
              .startOf('day')
              .diff(previousDay, 'days'),
            0
          ),
          1
        )
      : 0

    return nextDay
      .clone()
      .add(dayOffset, 'days')
      .hour(source.hour())
      .minute(source.minute())
      .second(source.second())
      .millisecond(source.millisecond())
      .toDate()
  }

  return {
    startTime: rebaseTime(startTime, false),
    splits: splits.map(split => ({
      ...split,
      date: rebaseTime(split.date, true),
    })),
  }
}

export const splitLogic = ({
  submitDate,
  splits,
  key,
  clinicalDepartmentId,
  date,
}) => {
  const formatSubmitTime = submitTime => {
    const m = moment(submitTime).second(0)
    if (date) {
      // For scheduled shifts: use `date` as base day,
      // but if submitTime falls on the next day (overnight shift), add 1 day
      const submitDay = moment(submitDate).startOf('day')
      const submitTimeDay = moment(submitTime).startOf('day')
      const isNextDay = submitTimeDay.isAfter(submitDay)
      const baseDate = isNextDay
        ? date.clone().add(1, 'day')
        : date.clone()
      return `${baseDate.format('YYYY-MM-DD')}T${m.format('HH:mm:ss')}`
    }
    return `${m.format('YYYY-MM-DD')}T${m.format('HH:mm:ss')}`
  }
  const args = {}
  if (splits.length > 1) {
    for (let i = 0; i < splits.length - 1; i += 1) {
      args[`splitDateTime${i + 1}`] = moment(splits[i].date).second(0)
      args[`splitHourlyWage${i + 1}`] = parseInt(splits[i].hourlyWage)
      args[`isSplitDateTime${i + 1}BreakTime`] = splits[i].isBreakTime
    }
  }
  if (splits[splits.length - 1]) {
    args.endTime = moment(splits[splits.length - 1].date).second(0)
    args.hourlyWage = parseInt(splits[splits.length - 1].hourlyWage)
    args.isStartTimeBreakTime = splits[splits.length - 1].isBreakTime
    args.startTime = splits[0].startTime
  }

  if (key) {
    let day = ''
    switch (key) {
      case '1':
        day = 'mon'
        break
      case '1_Hol':
        day = 'mon_hol'
        break
      case '2':
        day = 'tue'
        break
      case '2_Hol':
        day = 'tue_hol'
        break
      case '3':
        day = 'wed'
        break
      case '3_Hol':
        day = 'wed_hol'
        break
      case '4':
        day = 'thu'
        break
      case '4_Hol':
        day = 'thu_hol'
        break
      case '5':
        day = 'fri'
        break
      case '5_Hol':
        day = 'fri_hol'
        break
      case '6':
        day = 'sat'
        break
      case '6_Hol':
        day = 'sat_hol'
        break
      case '7':
        day = 'sun'
        break
      case '7_Hol':
        day = 'sun_hol'
        break
      case '8':
        day = 'hol'
        break
      default:
        break
    }

    const split = {}
    args.endTime = formatSubmitTime(args.endTime)
    args.startTime = formatSubmitTime(args.startTime)

    args.clinicalDepartmentId =
      clinicalDepartmentId || splits[0].clinicalDepartmentId
    args.splitDateTime1 =
      (args.splitDateTime1 && formatSubmitTime(args.splitDateTime1)) || null
    args.splitDateTime2 =
      (args.splitDateTime2 && formatSubmitTime(args.splitDateTime2)) || null
    args.splitDateTime3 =
      (args.splitDateTime3 && formatSubmitTime(args.splitDateTime3)) || null
    split[day] = args
    return split
  }
  return args
}

export default splitLogic
